import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'ERP',
		url: '/erp',
		icon: 'industry',
	},
	{
		name: 'Station Work',
		url: '/erp/work',
		icon: 'wrench',
	},
];

export default class MrpStationWork extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar
					breadcrumbs={breadcrumbsStatic}
					history={this.props.history}
				/>
				<Objects.MrpStationWork
					history={this.props.history}
				/>
			</div>
		);
	}
}
